import { render, staticRenderFns } from "./MessagesLog.vue?vue&type=template&id=546e5c47&scoped=true&"
import script from "./MessagesLog.vue?vue&type=script&lang=js&"
export * from "./MessagesLog.vue?vue&type=script&lang=js&"
import style0 from "./MessagesLog.vue?vue&type=style&index=0&id=546e5c47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546e5c47",
  null
  
)

export default component.exports